import { useAppContext } from '../store/AppContext';
import useApi from './useApi';

const useUserService = () => {
  const { api } = useApi();
  const [{ adminType }] = useAppContext();

  const getMe = () => api({
    method: 'get',
    url: `/identity-access/v1/${adminType}-admin-accounts/userinfo`,
  });

  return {
    getMe,
  };
};

export default useUserService;
